import React from 'react';
import GeneralStatus from '../../GeneralStatus';

/**
 * Mobile Player Avatar (General) Component
 * Positioned at bottom-left, above the resign button
 */
export const MobilePlayerAvatar = ({
  you,
  playerDamageFlash,
  playerRank,
  selectedGeneral,
  avatars,
  getAvatarImage,
  getDamageFlashStyles,
  shouldMirrorAvatar,
  getRankStyle,
  calculateFactionFromStrategy,
  getTranslatedFactionName,
  yourTurn
}) => {
  return (
    <div className="player-avatar-container-mobile" style={{ 
      position: "absolute", 
      left: "5px",
      bottom: "45px",
      zIndex: 1000,
      transform: "scale(0.4)",
      transformOrigin: "bottom left"
    }}>
      <div style={{ position: "relative", display: "inline-block" }}>
        <GeneralStatus
          health={you.health}
          intelligenceLeft={you.intelligence}
          intelligenceTotal={you.maxIntelligence}
          barriersRemoved={you.barriersRemoved ?? []}
          damageFlash={playerDamageFlash}
          playerCompact={true}
          factionName={calculateFactionFromStrategy(you.strategy)}
          translatedFactionName={getTranslatedFactionName(calculateFactionFromStrategy(you.strategy))}
          isActiveTurn={yourTurn}
        />
        <div style={{ position: "relative", width: "180px", height: "180px", display: "inline-block", overflow: "visible" }}>
          <img 
            src={getAvatarImage(selectedGeneral)} 
            alt="Player General"
            style={{ 
              width: "100%", 
              height: "100%", 
              objectFit: "contain",
              display: "block",
              ...getDamageFlashStyles(playerDamageFlash),
              transform: shouldMirrorAvatar(selectedGeneral, 'left', avatars) ? 'scaleX(-1)' : 'none',
              borderRadius: '8px'
            }} 
          />
          {playerRank !== null && playerRank !== undefined && (
            <div style={{
              ...getRankStyle(playerRank),
              position: "absolute",
              bottom: "2px",
              right: "8px",
              zIndex: 10002,
              fontSize: "22px",
              fontWeight: "bold",
              backgroundColor: "rgba(0, 0, 0, 0.85)",
              padding: "4px 8px",
              borderRadius: "6px",
              pointerEvents: "none"
            }}>
              #{playerRank}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobilePlayerAvatar;

